<div class="chat-component" [ngClass]="{'chat-hidden': !IsVisible}">
      <kendo-chat
      [messages]="feed"
      [user]="user"
      (sendMessage)="sendMessage($event)"
      messageBoxType="textarea"
      #kendoChatRef>
      <kendo-chat-messages
        send="{{'chat.send.btn' | translate }}"
        messagePlaceholder="{{(answerContextId == null ? 'chat.send.placeholder' : 'chat.sendanswer.placeholder') | translate }}" [title]="'chat.send.placeholder' | translate">>
      </kendo-chat-messages>
      <ng-template kendoChatMessageTemplate let-message>
            <div *ngIf="message.author.id == 0" class="message-me">
                  {{message.text}}
                  <span class="timestamp">{{getFormattedTimestamp(message.timestamp)}}</span>
            </div>
            <div *ngIf="message.author.id > 0" class="message-other" [attr.aria-label]="message.text">
                  <button *ngIf="answerContextId == null && isMessageAnswerable(message)" (click)="answerMessageClicked(message)" class="message-action-button k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-icon-button k-window-action k-dialog-action" title="{{ 'chat.reply.btn' | translate }}">
                        <span class="k-button-icon k-icon k-i-undo">
                        </span>
                  </button>
                  {{message.text}}
                  <span class="timestamp">{{getFormattedTimestamp(message.timestamp)}}</span>
            </div>
            <div *ngIf="message.author.id == -1" class="message-info">
                  {{message.text}}
                  <span class="timestamp">{{getFormattedTimestamp(message.timestamp)}}</span>
            </div>
            <div *ngIf="message.author.id == -2" class="message-other answer-select" [attr.aria-label]="message.text">
                  <button (click)="answerDismissClicked()" role="button" class="message-action-button k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-icon-button k-window-action k-dialog-action" title="{{ 'conformationDialog.cancel' | translate }}">
                        <span class="k-button-icon k-icon k-i-x">
                        </span>
                  </button>
                  {{message.text}}
                  <span class="timestamp">{{getFormattedTimestamp(message.timestamp)}}</span>
            </div>
      </ng-template>
</kendo-chat>
</div>
